const SESSION_EXPIRED_NOTICE_KEY = 'sessionExpiredNotice';

export const DEFAULT_SESSION_EXPIRED_MESSAGE =
  'Sua sessão expirou. Faça login novamente.';

const isBrowser = typeof window !== 'undefined';

const setNoticeValue = (value) => {
  if (!isBrowser) return;

  if (value === null || value === undefined || value === '') {
    window.sessionStorage?.removeItem(SESSION_EXPIRED_NOTICE_KEY);
    window.localStorage?.removeItem(SESSION_EXPIRED_NOTICE_KEY);
    return;
  }

  window.sessionStorage?.setItem(SESSION_EXPIRED_NOTICE_KEY, value);
  window.localStorage?.setItem(SESSION_EXPIRED_NOTICE_KEY, value);
};

export function markSessionExpiredNotice(
  message = DEFAULT_SESSION_EXPIRED_MESSAGE
) {
  setNoticeValue(message);
}

export function consumeSessionExpiredNotice() {
  if (!isBrowser) return null;

  const value =
    window.sessionStorage?.getItem(SESSION_EXPIRED_NOTICE_KEY) ??
    window.localStorage?.getItem(SESSION_EXPIRED_NOTICE_KEY);

  if (!value) return null;

  setNoticeValue(null);
  return value;
}

export function markExpectedSessionExpiry(error) {
  if (!error || typeof error !== 'object') return error;
  error.isExpectedSessionExpiry = true;
  return error;
}

export function isExpectedSessionExpiry(error) {
  if (error?.isExpectedSessionExpiry) return true;

  const status = error?.response?.status;
  if (status === 401) return true;

  return error?.message === 'Refresh token inválido';
}
